import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PagesList from "../components/PagesLlist";

const PagesPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Manage Pages' />

                <PagesList />

            </MasterLayout>
        </>
    );
};

export default PagesPage;
